import * as React from 'react';

import { Typography, Checkbox, Grid, FormGroup, FormControlLabel } from '@mui/material';

// const host = process.env.REACT_APP_HOST || 'localhost:5000';

export default function Settings() {
    const [showExperimentalData, setShowExperimentalData] = React.useState([]);
    const [displayPoints, setDisplayPoints] = React.useState(true);
    const [displayBoxes, setDisplayBoxes] = React.useState(false);
    const [displayIcons, setDisplayIcons] = React.useState(false);
    const [displayLines, setDisplayLines] = React.useState(false);
    const [display3DModels, setDisplay3DModels] = React.useState(false);
    const [displayMostRecentPoint3DModel, setDisplayMostRecentPoint3DModel] = React.useState(false);
    
    React.useEffect(() => {
        // load showExperimentalData from localStorage
        const showExperimentalData = localStorage.getItem('showExperimentalData') === 'true';
        const displayPoints = localStorage.getItem('SHOW_POINTS') === 'true';
        const displayBoxes = localStorage.getItem('SHOW_BOXES') === 'true';
        const displayIcons = localStorage.getItem('SHOW_ICONS') === 'true';
        const displayLines = localStorage.getItem('SHOW_LINES') === 'true';
        const display3DModels = localStorage.getItem('SHOW_MODEL_FOR_ALL_POINTS') === 'true';
        const displayMostRecentPoint3DModel = localStorage.getItem('SHOW_MODEL_FOR_LAST_POINT') === 'true';
        setShowExperimentalData(showExperimentalData);
        setDisplayPoints(displayPoints);
        setDisplayBoxes(displayBoxes);
        setDisplayIcons(displayIcons);
        setDisplayLines(displayLines);
        setDisplay3DModels(display3DModels);
        setDisplayMostRecentPoint3DModel(displayMostRecentPoint3DModel);
    }, []);

    return (
        <Grid container spacing={2}>
            <Grid item xs={10} textAlign='left'>
                <Typography variant="h6" gutterBottom>
                    Settings
                </Typography>
            </Grid>
            <Grid item xs={2} textAlign={'right'}>
            </Grid>
            <Grid item xs={12} textAlign='left'>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={showExperimentalData}
                                onChange={(event) => {
                                    const showExperimentalData = event.target.checked;
                                    setShowExperimentalData(showExperimentalData);
                                    localStorage.setItem('showExperimentalData', showExperimentalData);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Show Experimental Data"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={displayPoints}
                                onChange={(event) => {
                                    const displayPoints = event.target.checked;
                                    setDisplayPoints(displayPoints);
                                    localStorage.setItem('SHOW_POINTS', displayPoints);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Display Points"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={displayIcons}
                                onChange={(event) => {
                                    const displayIcons = event.target.checked;
                                    setDisplayIcons(displayIcons);
                                    localStorage.setItem('SHOW_ICONS', displayIcons);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Display Icons"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={displayBoxes}
                                onChange={(event) => {
                                    const displayBoxes = event.target.checked;
                                    setDisplayBoxes(displayBoxes);
                                    localStorage.setItem('SHOW_BOXES', displayBoxes);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Display Boxes"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={displayLines}
                                onChange={(event) => {
                                    const displayLines = event.target.checked;
                                    setDisplayLines(displayLines);
                                    localStorage.setItem('SHOW_LINES', displayLines);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Display Lines"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={display3DModels}
                                onChange={(event) => {
                                    const display3DModels = event.target.checked;
                                    setDisplay3DModels(display3DModels);
                                    localStorage.setItem('SHOW_MODEL_FOR_ALL_POINTS', display3DModels);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Display 3D Models"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={displayMostRecentPoint3DModel}
                                onChange={(event) => {
                                    const displayMostRecentPoint3DModel = event.target.checked;
                                    setDisplayMostRecentPoint3DModel(displayMostRecentPoint3DModel);
                                    localStorage.setItem('SHOW_MODEL_FOR_LAST_POINT', displayMostRecentPoint3DModel);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label="Display Most Recent Point 3D Model"
                    />
                </FormGroup>
            </Grid>
        </Grid>
    );
}